window.AG = window.AG || {};

AG.fontMerriweather = new FontFaceObserver('Merriweather');
AG.fontRobotoSlab = new FontFaceObserver('Roboto Slab');
AG.fontRoboto = new FontFaceObserver('Roboto');